import React, { useContext } from 'react'
import { selectionDataContext } from '../../../hooks/context/SelectionDataContext'

const useTablesDataHook = () => {
    const selectionDataCtx:any = useContext(selectionDataContext)
    const payload=selectionDataCtx.data
  return payload
}

export default useTablesDataHook